import { EMPTY_LIST, EMPTY_STRING } from '../../../constants/common'

export const BUILDING_FORM_FIELD_NAME_ADDRESS = 'address'

export const BUILDING_FORM_FIELD_NAME_AVATAR = 'avatar'

export const BUILDING_FORM_FIELD_NAME_BANK_NAME = 'bank_name'

export const BUILDING_FORM_FIELD_NAME_BANK_OWNER = 'bank_account_owner'

export const BUILDING_FORM_FIELD_NAME_BIC = 'bic'

export const BUILDING_FORM_FIELD_NAME_BUILDING_GROUP = 'building_groups'

// read only field with computed value from address & number fields value
export const BUILDING_FORM_FIELD_NAME_BUILDING_NAME = 'name'

export const BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER = 'object_number'

export const BUILDING_FORM_FIELD_NAME_CONTRACT_START = 'contract_start'

export const BUILDING_FORM_FIELD_NAME_FILES = 'files'

export const BUILDING_FORM_FIELD_NAME_IBAN = 'iban'

export const BUILDING_FORM_FIELD_NAME_INSURANCES = 'insurance'

export const BUILDING_FORM_FIELD_NAME_NOTES = 'notes'

export const BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER = 'responsible_users'

export const BUILDING_FORM_FIELD_NAME_TYPE_OF_BUILDING = 'living_type'

export const BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP =
  'update_responsible_users'

export const BUILDING_FORM_INSURANCE_FIELD_NAME_CONTRACT_NUMBER =
  'contract_number'

export const BUILDING_FORM_INSURANCE_FIELD_NAME_INSURANCE_TYPE =
  'insurance_type'

export const BUILDING_FORM_INSURANCE_FIELD_NAME_SUPPLIER = 'supplier'

export const BUILDING_FORM_ADDRESS_FIELD_MAX_LENGTH = 500

export const BUILDING_FORM_BANK_NAME_FIELD_MAX_LENGTH = 256

export const BUILDING_FORM_BANK_OWNER_FIELD_MAX_LENGTH = 256

export const BUILDING_FORM_BIC_FIELD_MAX_LENGTH = 11

export const BUILDING_FORM_BUILDING_NUMBER_FIELD_MAX_LENGTH = 30

export const BUILDING_FORM_IBAN_FIELD_MAX_LENGTH = 34

export const BUILDING_FORM_NOTES_FIELD_MAX_LENGTH = 2000

export const BUILDING_FORM_INSURANCE_CONTRACT_NUMBER_FIELD_MAX_LENGTH = 50

export const BUILDING_FORM_INITIAL_VALUES = {
  [BUILDING_FORM_FIELD_NAME_ADDRESS]: null,
  [BUILDING_FORM_FIELD_NAME_AVATAR]: null,
  [BUILDING_FORM_FIELD_NAME_BANK_NAME]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_BANK_OWNER]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_BIC]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_BUILDING_GROUP]: EMPTY_LIST,
  [BUILDING_FORM_FIELD_NAME_BUILDING_NAME]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_CONTRACT_START]: null,
  [BUILDING_FORM_FIELD_NAME_IBAN]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_INSURANCES]: EMPTY_LIST,
  [BUILDING_FORM_FIELD_NAME_NOTES]: EMPTY_STRING,
  [BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER]: EMPTY_LIST,
  [BUILDING_FORM_FIELD_NAME_TYPE_OF_BUILDING]: null,
  [BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP]: false,
}

export const BUILDING_FORM_INSURANCE_INITIAL_VALUES = {
  [BUILDING_FORM_INSURANCE_FIELD_NAME_CONTRACT_NUMBER]: EMPTY_STRING,
  [BUILDING_FORM_INSURANCE_FIELD_NAME_INSURANCE_TYPE]: null,
  [BUILDING_FORM_INSURANCE_FIELD_NAME_SUPPLIER]: null,
}

export const BUILDING_FORM_REQUIRED_FIELDS = [BUILDING_FORM_FIELD_NAME_ADDRESS]
